const home = {
  'newsletter-unsubscribed-successfully': 'Te has dado de baja del boletín informativo',
  'newsletter-verification-successfully': 'Verificacion completada. Pronto recibirás novedades de nuestra parte. Gracias por elegirnos.'
};

export default home;
